import React, { useState, useRef, useEffect } from 'react'
import { Card } from 'component'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { message } from 'meinian-package/src/utils'
import { SwitchPageTabContent } from '../../components/switchTab'
import styles from './index.module.less'

export const SCREEN_VALUE = {
  STYLE: 1,
  INSPIRATION: 2
}

const SCREEN_DATA = [
  {
    label: '款式',
    value: SCREEN_VALUE.STYLE
  },
  {
    label: '灵感集',
    value: SCREEN_VALUE.INSPIRATION
  }
]

export default () => {
  const [screenValue, setScreenValue] = useState(SCREEN_VALUE.STYLE)
  const $masonry = useRef()
  useEffect(() => {
    const subUploadRecycle = () => {
      $masonry.current?.init()
    }
    message.sub('subUploadRecycle', subUploadRecycle)
    return () => {
      message.remove('subUploadRecycle', subUploadRecycle)
    }
  }, [])

  return (
    <div className={styles['recycle-container']}>
      <div className="header">
        <div className="title">回收站</div>
        <div className="header-switch">
          <SwitchPageTabContent
            value={screenValue}
            options={SCREEN_DATA}
            onChange={value => setScreenValue(value)}
          />
        </div>
      </div>
      <div style={{ paddingTop: 24 }}>
        <MNWaterfallApi
          renderItem={Card.RecoverCard}
          cardProps={{ screenValue }}
          url={screenValue === SCREEN_VALUE.STYLE ? 'zhikuan/mn/recycle-bin/inspiration-blog' : 'zhikuan/mn/recycle-bin/inspiration'}
          method="spost"
          params={{}}
          ref={$masonry}
          afterLoad={() => {}}
          emptyText={`暂无相关${SCREEN_DATA.find(item => item.value === screenValue).label}`}
          emptyType="image"
        />
      </div>
    </div>
  )
}
